<template>
  <div class="slider-container" v-if="list && list.length">
    <Carousel
        class="products"
        ref="carousel"
        :items-to-show="slidesToShow"
        :wrap-around="false"
        :mouse-drag="true"
        :snap-align="'start'"
        @slideChange="handleSlideChange"
        @dragStart="handleSwipe"
    >
      <Slide
          v-for="item in list"
          :key="item.id"
          class="item"
      >
        <ProductCard
            :isPack="isPack"
            :lazy="false"
            :item="item"
            :tag="tag"
            :currency="currency"
            :isAuth="isAuth"
            :activePack="activePack"
            :sliderIsClickble="sliderIsClickble"
            @goToProduct="goToProduct"
            @openReadyModal="openReadyModal"
            @openSignInModal="openSignInModal"
        />
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import ProductCard from '../components/ProductCard.vue';

export default defineComponent({
  name: 'CarouselItem',
  emits: ['goToProduct', 'openReadyModal', 'openSignInModal'],
  props: ['list', 'tag', 'currency', 'isPack', 'activePack', 'isAuth'],
  components: {
    Carousel,
    Slide,
    ProductCard
  },
  setup(props, { emit }) {
    const carousel = ref(null);
    const sliderIsClickble = ref(true);

    const calculateSlidesToShow = () => {
      const width = window.innerWidth;
      if (width >= 1200) return 4;
      if (width >= 901) return 2;
      if (width >= 601) return 2;
      return 1;
    };

    const slidesToShow = ref(calculateSlidesToShow());

    const handleResize = () => {
      slidesToShow.value = calculateSlidesToShow();
      nextTick(() => {
        if (carousel.value) {
          carousel.value.slideTo(carousel.value.currentSlide);
        }
      });
    };

    const handleSwipe = () => {
      sliderIsClickble.value = false;
      setTimeout(() => {
        sliderIsClickble.value = true;
      }, 300);
    };

    const goToProduct = (item) => {
      emit('goToProduct', item);
    };

    const openReadyModal = (item, product) => {
      emit('openReadyModal', item, product);
    };

    const openSignInModal = () => {
      emit('openSignInModal');
    };

    const handleSlideChange = () => {
      // Добавь сюда логику, если нужна реакция на смену слайда
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      carousel,
      slidesToShow,
      sliderIsClickble,
      handleSwipe,
      handleSlideChange,
      goToProduct,
      openReadyModal,
      openSignInModal,
    };
  }
});
</script>

<style scoped>
</style>
